import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { updateConfigPtMonAnalogico } from './services'

const initialState: any = {
  status: "",
  data: [],
  msgError: ""
}

export const actionUpdateConfigPtMonAnalogico: any = createAsyncThunk<any, any>(
  "ACTION_UPDATE_CONFIG_PT_MON_ANALOGICO",
  async (data, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
      getPtMonAnalogico,
      equipamentos: { dataUnidadeDeMedida },
    } = getState();

    return updateConfigPtMonAnalogico(getPtMonAnalogico.data.id, {...data, idLoja: lojaSelected})
  }
)

const sliceUpdateConfigPtMonAnalogico = createSlice({
  name: "UPDATE_CONFIG",
  initialState,
  reducers: {
    actionResetStateUpdadePtMonAnalogico: (state) => {
      state.status = ""
      state.msgError = ""
    }
  },
  extraReducers: {
    [actionUpdateConfigPtMonAnalogico.pending]: (state) => {
      state.status = "loading"
    },
    [actionUpdateConfigPtMonAnalogico.fulfilled]: (state, { payload }) => {
      state.status = "success"
      state.data = payload
    },
    [actionUpdateConfigPtMonAnalogico.rejected]: (state, { error: { message } }) => {
      state.status = "error"
      state.msgError = message
    },
  }
})

export default sliceUpdateConfigPtMonAnalogico.reducer
export const { actionResetStateUpdadePtMonAnalogico } =
  sliceUpdateConfigPtMonAnalogico.actions;